import React, { useContext } from 'react';
import styles from './InitiativeCardDetailsList.module.scss';
import {
  InitiativeCounters,
  InitiativeRow
} from '../../../../../../../../Models/InitiativeValue';
import { MediaContext } from 'ui-smartforce-settings';
import { MobileInitiativeTable } from './MobileInitiativeTable/MobileInitiativeTable';
import { InitiativeTable } from './InitiativeTable/InitiativeTable';

export const INITIATIVE_REPORTS_LIMIT = 1000;

export interface InitiativeCardDetailsListProps {
  className?: string;
  counters: InitiativeCounters;
  rows: InitiativeRow[];
  onSeeDateRowReports: (index: number) => void;
}

export const InitiativeCardDetailsList = ({
  className = '',
  counters,
  rows,
  onSeeDateRowReports
}: InitiativeCardDetailsListProps): React.ReactElement<InitiativeCardDetailsListProps> => {
  const { isPhone } = useContext(MediaContext);

  return (
    <div className={`${styles.initiativeCardDetailsList} ${className}`}>
      {isPhone && (
        <MobileInitiativeTable
          counters={counters}
          rows={rows}
          onSeeDateRowReports={onSeeDateRowReports}
        />
      )}
      {!isPhone && (
        <InitiativeTable
          counters={counters}
          rows={rows}
          onSeeDateRowReports={onSeeDateRowReports}
        />
      )}
    </div>
  );
};
